/*global d3 */
'use strict';
const SVG_HEIGHT = 50;
const SVG_WIDTH = 640;
const SVG_LEFT_PAD = 80;
const SVG_RIGHT_PAD = 80;
const SVG_PROGRESS_WIDTH = SVG_WIDTH - SVG_LEFT_PAD - SVG_RIGHT_PAD;

export default class TennisShotDataView {

  constructor (videoid, impactPoints, swingTypes) {
    this.shots = [];
    this.creationTime = '';
    this.videoDuration = 0;
    this.videoStartTime = '';
    this.drawingShotIndex = -1;
    this.drawingShotTime = 0;
    this.videoid = videoid;
    this.impactPoints = impactPoints;
    this.swingTypes = swingTypes;

    this.videoImpactPointMapper = this.createVideoMap();

    let svg = d3.select(videoid).select('#shotracket').append('svg')
    .attr('preserveAspectRatio', 'xMinYMin meet')
    // このSVG要素全体の枠、のサイズこれに対する比率で描画すればScaleしても追従する
    // TBD: ラケット画像の値にしているがあとで玉の当たる位置合わせで微調整必要
    .attr('viewBox', '0 0 128 114')
    .classed('svg-content', true);

    svg.append('image', 'g')
    .attr('xlink:href', './res/racket.png')
    .attr('width', '100%')
    .attr('height', '100%');

    this.shotsvg = svg.append('g')
    .attr({
      transform: function (d) {
        return 'translate(' +
         -10.0 + ',' +
         -10.0 + ')';
      }
    });
    this.shotsvg.append('circle')
    .attr({
      'r': function (d) { return 10; },
      'fill': function (d, i) { return '#eeee00'; }
    });

    svg = d3.select(videoid).select('#shotinfo').append('svg')
    .attr('preserveAspectRatio', 'xMinYMin meet')
    // このSVG要素全体の枠（元のVideoのサイズで調整したので640=100%にしている）
    // これに対する比率で描画すればScaleしても追従する
    .attr('viewBox', '0 0 640 75')
    .classed('svg-content', true);
    svg.append('rect')
    .attr({
      'x': 0,
      'y': 0,
      'width': '100%',
      'height': '100%',
      'fill': 'black',
      'opacity': 0.5
    });

    this.swingType = svg.append('text')
    .attr({
      'x': '120',
      'y': '12',
      'font-size': '12',
      'fill': '#ffffff',
      'stroke-width': '1'
    });
    svg.append('text')
    .attr({
      'x': '300',
      'y': '12',
      'font-size': '12',
      'fill': '#ffffff',
      'stroke-width': '1'
    })
    .text('ボール回転');
    this.ballSpin = svg.append('text')
    .attr({
      'x': '300',
      'y': '38',
      'font-size': '24',
      'fill': '#ffffff',
      'stroke-width': '1'
    });
    svg.append('text')
    .attr({
      'x': '400',
      'y': '12',
      'font-size': '12',
      'fill': '#ffffff',
      'stroke-width': '1'
    })
    .text('スイング速度');
    this.swingSpeed = svg.append('text')
    .attr({
      'x': '410',
      'y': '38',
      'font-size': '24',
      'fill': '#ffffff',
      'stroke-width': '1'
    });
    svg.append('text')
    .attr({
      'x': '460',
      'y': '38',
      'font-size': '12',
      'fill': '#ffffff',
      'stroke-width': '1'
    })
    .text('km/h');
    svg.append('text')
    .attr({
      'x': '500',
      'y': '12',
      'font-size': '12',
      'fill': '#ffffff',
      'stroke-width': '1'
    })
    .text('ボール速度');
    this.ballSpeed = svg.append('text')
    .attr({
      'x': '510',
      'y': '38',
      'font-size': '24',
      'fill': '#ffffff',
      'stroke-width': '1'
    });
    svg.append('text')
    .attr({
      'x': '560',
      'y': '38',
      'font-size': '12',
      'fill': '#ffffff',
      'stroke-width': '1'
    })
    .text('km/h');

    TennisShotDataView.$inject = ['videoid', 'impactPoints', 'swingTypes'];
  }

  // Implementation ---------------------------------------
  appendShots (shots, start, end) {
    if (!shots) {
      console.error('shot response timing issue');
    }
    if (end < shots[0].date || shots[shots.length - 1].date < start) {
      console.error('video range mismatched');
      return;
    }

    let startIndex = -1;
    let endIndex = -1;
    for (let i = 0; i < shots.length; i++) {
      if (start < shots[i].date) {
        startIndex = i;
        break;
      }
    }
    for (let j = startIndex; j < shots.length; j++) {
      if (end < shots[j].date) {
        endIndex = j;
        break;
      }
      if (j === (shots.length - 1)) {
        endIndex = shots.length;
        break;
      }
    }
    if (startIndex === -1 || endIndex === -1 || endIndex < startIndex) {
      console.error('video and shot data mismatched');
      return;
    }
    this.videoStartTime = start;
    this.videoDuration = end - start;
    this.shots = shots.slice(startIndex, endIndex);
  }

  updateShots (time, videoHeight, videoWidth) {
    if (!this.shots) return;
    this.updateTimeline(time);

    // 若干描画を速めたいので0.7秒描画判定時刻は先送り
    time = 0.7 + time;

    // 再生が戻った時は最初のshotから検索
    if (time * 1000 < this.drawingShotTime) {
      this.clearShot();
      this.drawingShotIndex = -1;
    }

    let end = this.shots.length - 1;

    // Shotのupdateが必要なければ終了
    if (this.drawingShotIndex === end || time * 1000 < (this.shots[this.drawingShotIndex + 1].date - this.videoStartTime)) {
      return;
    }

    // 該当ショットを検索
    for (let i = this.drawingShotIndex + 1; i <= end; i++) {
      if (i === end || time * 1000 < (this.shots[i + 1].date - this.videoStartTime)) {
        this.drawingShotIndex = i;
        this.drawingShotTime = this.shots[i].date - this.videoStartTime;
        break;
      }
    }

    let point = this.shots[this.drawingShotIndex].impact_point;
    this.updateShot(point);
  }

  updateShot (point) {
    this.shotsvg.attr({
      transform: (d) => {
        return 'translate(' +
         this.videoImpactPointMapper[point].x + ',' +
         this.videoImpactPointMapper[point].y + ')';
      }
    });
    let spinsigned = (this.shots[this.drawingShotIndex].spin > 0) ? '+' : '';
    this.swingType.text(this.shots[this.drawingShotIndex].swing_type);
    this.ballSpin.text(spinsigned + this.shots[this.drawingShotIndex].spin);
    this.ballSpeed.text(this.shots[this.drawingShotIndex].hitball_speed);
    this.swingSpeed.text(this.shots[this.drawingShotIndex].swing_speed.toFixed(0));
  }

  clearShot () {
    // impact pointの位置を再生前に戻す
    this.shotsvg.attr({
      transform: (d) => {
        return 'translate(' +
         -10 + ',' +
         -10 + ')';
      }
    });
    // 描画されたショット情報を空文字で更新
    this.swingType.text('');
    this.ballSpin.text('');
    this.ballSpeed.text('');
    this.swingSpeed.text('');
  }

  createVideoMap () {
    const X_OFFSET = 31;
    const X_SCALE = 11;
    const Y_OFFSET = 8;
    const Y_SCALE = 11;

    let array = [];
    for (let i = 0; i < this.impactPoints.length; i++) {
      array.push({x: X_OFFSET + X_SCALE * this.impactPoints[i][0],
        y: Y_OFFSET + Y_SCALE * this.impactPoints[i][1] });
    }
    return array;
  }

  // shot のタイムラインは8月は表示しないので呼び出されないが、
  // 実装を残しておく
  addShotBar () {
    let svg = d3.select(this.videoid).select('#shotbar').append('svg')
    .attr({
      width: SVG_WIDTH,
      height: SVG_HEIGHT
    });

    svg.append('rect')
    .attr({
      'x': 0,
      'y': 0,
      'width': SVG_WIDTH,
      'height': 50,
      'fill': 'black',
      'opacity': 0.5
    });

    let that = this;
    let g = svg.selectAll('g')
    .data(this.shots).enter().append('g')
    .attr({
      transform: (d) => {
        let tp = 1.0 * (d.date - that.videoStartTime) / that.videoDuration;
        return 'translate(' + (1.0 * SVG_LEFT_PAD + Math.floor(tp * SVG_PROGRESS_WIDTH)) + ',' + SVG_HEIGHT / 2 + ')';
      }
    });

    g.append('circle')
    .attr({
      'r': (d) => { return 10; },
      'fill': (d, i) => {
        let label = that.swingTypes.getLabel(d.swing_id);
        return that.swingTypes.getColorByLabel(label);
      }
    });
    g.append('text')
    .attr({
      'text-anchor': 'middle',
      'dy': '.35em',
      'fill': 'white'
    })
    .text(function (d, i) { return i + 1; });

    svg.append('g')
    .attr({
      transform: function (d) {
        return 'translate(' +
         0.0 + ',' +
         0.0 + ')';
      }
    })
    .append('line')
    .attr({
      'x1': '0',
      'y1': '0',
      'x2': '0',
      'y2': '0',
      'stroke': '#ffffff'
    });
  }

  // こちらも8月のテストマーケではタイムラインは表示しないことになったが
  // 実装は残しておく
  updateTimeline (time) {
    let line = d3.select(this.videoid).select('#shotbar').select('svg').selectAll('line');
    if (!line) {
      console.error('no line found!!');
    }
    let percent = (1000.0 * time) / this.videoDuration;
    line.attr({
      'x1': '' + (1.0 * SVG_LEFT_PAD + Math.floor(percent * SVG_PROGRESS_WIDTH)) + '',
      'y1': '0',
      'x2': '' + (1.0 * SVG_LEFT_PAD + Math.floor(percent * SVG_PROGRESS_WIDTH)) + '',
      'y2': '' + SVG_HEIGHT + '',
      'stroke': '#ffffff'
    });
  }

}



// WEBPACK FOOTER //
// ./app/lib/tennis-shot-data-view.es6